module.exports = __webpack_public_path__ + "img/ipage 2.14113dbe.png";